import { render, staticRenderFns } from "./M-focus.vue?vue&type=template&id=7c270892&scoped=true&"
import script from "./M-focus.vue?vue&type=script&lang=js&"
export * from "./M-focus.vue?vue&type=script&lang=js&"
import style0 from "./M-focus.vue?vue&type=style&index=0&id=7c270892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c270892",
  null
  
)

export default component.exports